// extracted by mini-css-extract-plugin
module.exports = {"container":"_1DFcK","table":"_1AAqr"};